module.exports = __webpack_public_path__ + "0f69dc6325c0ac9dcdb374c0ca8f6f33.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-40@2x.png
// module id = 516
// module chunks = 0